module.exports = __webpack_public_path__ + "../resources/images/sky-base-6e9cf1f3561e115148943d5dfbc9cee2.png";